// extracted by mini-css-extract-plugin
module.exports = {"text":"classic_text_39Ghj","classicList":"classic_classicList_3nkym","classicItem":"classic_classicItem_2LJWp","btn":"classic_btn_2hhHP"};